import Home from '../components/pages/Home';

export default function Root() {
  return <Home />;
}
